export default __webpack_public_path__ + "static/media/javascript.c69f401d.png";